import { sub, add } from 'date-fns';

import { CUSTOM_DATES_TITLE } from '../components/dateFilterMenuItems';

export function getDateFilterDates(
  selectedDateRange: { start: Duration; end?: Duration } | undefined,
  dateFilterSearchParam: string | null,
  defaultCurrentDate?: Date,
  options?: { futureHeadPaddingMs?: number }
) {
  const customSelectedDate = dateFilterSearchParam?.includes(CUSTOM_DATES_TITLE)
    ? dateFilterSearchParam.split('|').filter((str) => str !== CUSTOM_DATES_TITLE)
    : undefined;

  const currentDate = defaultCurrentDate || new Date();
  currentDate.setMilliseconds(0);

  const { start: activeFilterStartDuration, end: activeFilterEndDuration } =
    selectedDateRange || {};

  const endDurationKey = Object.keys(activeFilterEndDuration || {})[0] as keyof Duration;

  const calculatedEndDuration =
    activeFilterEndDuration?.minutes && currentDate.getMinutes() < activeFilterEndDuration?.minutes
      ? { [endDurationKey]: currentDate.getMinutes() }
      : activeFilterEndDuration?.seconds &&
          currentDate.getSeconds() < activeFilterEndDuration?.seconds
        ? { [endDurationKey]: currentDate.getSeconds() }
        : { [endDurationKey]: 0 };

  const selectedDates = customSelectedDate
    ? customSelectedDate
    : (() => {
        const startIso = sub(currentDate, activeFilterStartDuration || { hours: 3 }).toISOString();
        const rawEndIso = activeFilterEndDuration
          ? sub(currentDate, calculatedEndDuration).toISOString()
          : currentDate.toISOString();
        // Apply future head padding only for preset (non-custom) ranges to absorb clock skew.
        const futurePadding = options?.futureHeadPaddingMs || 0;
        const paddedEndIso = futurePadding
          ? add(new Date(rawEndIso), { seconds: Math.floor(futurePadding / 1000) }).toISOString()
          : rawEndIso;
        return [startIso, paddedEndIso];
      })();

  return selectedDates;
}
